import { http } from '@/lib/http';

/**
 * Shape returned by `POST /auth/sync` — mirrors `repo.User` in the
 * vizitpro-api swagger spec (`definitions.repo.User`).
 */
export interface SyncedUser {
  avatar_url: string | null;
  created_at: string;
  email: string | null;
  firebase_uid: string | null;
  full_name: string | null;
  id: string;
  phone: string | null;
  preferred_language: string | null;
  updated_at: string;
}

/**
 * Calls `POST /auth/sync`. The API verifies the Firebase token server-side
 * and finds-or-creates the backend `users` row, attaching `firebase_uid`.
 *
 * Must be called once per fresh sign-in/sign-up — before any other backend
 * call is trusted — since it's also how the backend learns about brand-new
 * Firebase accounts (email/password sign-up, Google sign-in).
 */
export async function syncUser(): Promise<SyncedUser> {
  const { data } = await http.post<SyncedUser>('/auth/sync');
  return data;
}
